import script from "./Reporting.vue?vue&type=script&lang=ts&setup=true"
export * from "./Reporting.vue?vue&type=script&lang=ts&setup=true"

import "./Reporting.vue?vue&type=style&index=0&id=69771932&lang=scss"

const __exports__ = script;

export default __exports__